<template>
  <div class="mall-category-section">
    <span v-if="heading" class="typo-md-semi">{{ heading }}</span>
    <MallSectionTitle :title="title" @more-click="$emit('more-click')" />
    <div class="mall-category-section__products">
      <MallProductCard
        v-for="product in products"
        :key="product.id"
        :product="product"
        :size="'sm'"
        @click="$emit('product-click', product)"
      />
    </div>
  </div>
</template>

<script>
import MallSectionTitle from '@/components/new/molecules/MallSectionTitle.vue'
import MallProductCard from '@/components/new/molecules/MallProductCard.vue'

export default {
  name: 'MallCategorySection',
  components: {
    MallSectionTitle,
    MallProductCard,
  },
  props: {
    // 섹션 위 안내 문구 (첫 섹션만)
    heading: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    products: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped>
.mall-category-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* 우측은 화면 끝까지 가로 스크롤 */
.mall-category-section__products {
  display: flex;
  margin-right: -16px;
  padding-right: 16px;
  align-items: flex-start;
  gap: 8px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.mall-category-section__products::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallCategorySection.vue